import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import { formatDate } from '@fund/basic-lib/dist/lib/date';
import { numeral } from '@fund/basic-lib/dist/lib/numeral';
import tool from './tool';

// 获取风险等级
function getRiskLevel(level) {
  if (isEmpty(level)) {
    return '--';
  }
  const risk = level === '--' || level === '' ? '低风险' : `${['低', '中低', '中', '中高', '高'][level - 1]}风险`;
  return risk;
}

// 处理头部标签
function handleHeaderTags(params) {
  const {
    fType, fundCode, bagType, riskLevel, rLevelCx, fundName, tTypeName, tType,
  } = params;
  const headerTags = [];
  let temp = {};
  if (!isEmpty(fType)) {
    temp = {
      type: 'FTYPE',
      tag: fType,
      eventName: 'pz.top.type',
      linkInfo: {
        type: 2,
        url: `fund://mp.1234567.com.cn/weex/b34ccfc4ed9a4af4a4880fee485cf417/pages/FundDetailInfo?FCODE=${fundCode}`,
      },
    };
  }
  // 活期宝就不需要类型
  if (!isEmpty(bagType) && bagType === '1') {
    temp = {
      tag: '活期宝',
      eventName: 'pz.top.type',
      linkInfo: {
        type: 2,
        url: `fund://mp.1234567.com.cn/weex/b34ccfc4ed9a4af4a4880fee485cf417/pages/FundDetailInfo?FCODE=${fundCode}`,
      },
    };
  }
  if (temp.tag) {
    headerTags.push(temp);
  }

  if (!isEmpty(getRiskLevel(riskLevel))) {
    const level = getRiskLevel(riskLevel);
    headerTags.push({
      tag: level,
      eventName: 'pz.top.risk',
      linkInfo: {
        type: 2,
        url: `fund://mp.1234567.com.cn/weex/b34ccfc4ed9a4af4a4880fee485cf417/pages/FundDetailInfo?FCODE=${fundCode}`,
      },
    });
  }
  if (!isEmpty(rLevelCx) && rLevelCx - 0 === 5) {
    headerTags.push({
      tag: '晨星五星评级',
      eventName: 'pz.tbkp.szpjbq.click',
      linkInfo: {
        type: 2,
        url: `fund://mp.1234567.com.cn/weex/516939c37bdb4ba2b1138c50cf69a2e1/pages/FundStageIncrease?fundCode=${fundCode}&fundName=${fundName}&pagetype=3`,
      },
    });
  }
  // 主题接AB测
  if (!isEmpty(tTypeName)) {
    headerTags.push({
      tag: tTypeName,
      eventName: 'pz.tbkp.jjzt.click',
      linkInfo: {
        type: 2,
        url: `fund://mp.1234567.com.cn/weex/fund6c2d8b95cc8e4b/pages/HotPlateDetailPage?bkcode=${tType}`,
      },
    });
  }
  const list = headerTags.map((item) => ({
    ...item,
    color: '#3A90FA',
    backgroundColor: '#F0F6FF',
  }));
  return list;
}

// 处理定投列表
function handleFixedInvestList(params) {
  const {
    ptdtY,
    ptdtTwy,
    ptdtTry,
    ptdtFy,
    dwdtY,
    dwdtTwy,
    dwdtTry,
    dwdtFy,
    mbdtY,
    mbdtTwy,
    mbdtTry,
    mbdtFy,
    yddtY,
    yddtTwy,
    yddtTry,
    yddtFy,
    bestDtY,
    bestDtTwy,
    bestDtTry,
    bestDtFy,
    bFundType,
  } = params;
  return [
    {
      date: '近1年',
      ptdt: isEmpty(ptdtY) ? '--' : `${numeral(ptdtY).format('0.00')}%`,
      dwdt: isEmpty(dwdtY) ? '--' : `${numeral(dwdtY).format('0.00')}%`,
      mbdt: isEmpty(mbdtY) ? '--' : `${numeral(mbdtY).format('0.00')}%`,
      yddt: isEmpty(yddtY) ? '--' : `${numeral(yddtY).format('0.00')}%`,
      bestDt: isEmpty(bestDtY) ? '--' : `${numeral(bestDtY).format('0.00')}%`,
      isShowSmartInvest: ['001', '002', '007'].indexOf(bFundType) >= 0,
    },
    {
      date: '近2年',
      ptdt: isEmpty(ptdtTwy) ? '--' : `${numeral(ptdtTwy).format('0.00')}%`,
      dwdt: isEmpty(dwdtTwy) ? '--' : `${numeral(dwdtTwy).format('0.00')}%`,
      mbdt: isEmpty(mbdtTwy) ? '--' : `${numeral(mbdtTwy).format('0.00')}%`,
      yddt: isEmpty(yddtTwy) ? '--' : `${numeral(yddtTwy).format('0.00')}%`,
      bestDt: isEmpty(bestDtTwy) ? '--' : `${numeral(bestDtTwy).format('0.00')}%`,
      isShowSmartInvest: ['001', '002', '007'].indexOf(bFundType) >= 0,
    },
    {
      date: '近3年',
      ptdt: isEmpty(ptdtTry) ? '--' : `${numeral(ptdtTry).format('0.00')}%`,
      dwdt: isEmpty(dwdtTry) ? '--' : `${numeral(dwdtTry).format('0.00')}%`,
      mbdt: isEmpty(mbdtTry) ? '--' : `${numeral(mbdtTry).format('0.00')}%`,
      yddt: isEmpty(yddtTry) ? '--' : `${numeral(yddtTry).format('0.00')}%`,
      bestDt: isEmpty(bestDtTry) ? '--' : `${numeral(bestDtTry).format('0.00')}%`,
      isShowSmartInvest: ['001', '002', '007'].indexOf(bFundType) >= 0,
    },
    {
      date: '近5年',
      ptdt: isEmpty(ptdtFy) ? '--' : `${numeral(ptdtFy).format('0.00')}%`,
      dwdt: isEmpty(dwdtFy) ? '--' : `${numeral(dwdtFy).format('0.00')}%`,
      mbdt: isEmpty(mbdtFy) ? '--' : `${numeral(mbdtFy).format('0.00')}%`,
      yddt: isEmpty(yddtFy) ? '--' : `${numeral(yddtFy).format('0.00')}%`,
      bestDt: isEmpty(bestDtFy) ? '--' : `${numeral(bestDtFy).format('0.00')}%`,
      isShowSmartInvest: ['001', '002', '007'].indexOf(bFundType) >= 0,
    },
  ];
}

// 基金规模
function formatFundSize(value) {
  if (value >= 1000000) {
    return `${(value / 100000000).toFixed(2)}亿`;
  }
  if (value >= 100) {
    return `${(value / 10000).toFixed(2)}万`;
  }
  return value;
}

// 格式化天数
function formatDays(days) {
  if (!isEmpty(days)) {
    const daysInt = parseInt(days, 10);
    if (daysInt < 365) {
      return `${daysInt}天`;
    }
    if (daysInt === 365) {
      return '1年';
    }
    return `${parseInt(String(daysInt / 365.0), 10)}年又${daysInt % 365}天`;
  }
  return '--';
}

// 特色数据
function handleFeatureData(params) {
  const { data, BTYPE } = params;

  const configMap = {
    volatility: ['波动较大', '波动尚可', '波动较低', '波动很小'],
    sharp: ['性价比较低', '性价比尚可', '性价比较高', '性价比很高'],
    maxReturn: ['回撤较大', '回撤尚可', '回撤较小', '回撤很低'],
    trackingError: ['跟踪误差大', '跟踪误差较大', '跟踪误差较小', '跟踪误差小'],
  };

  const descMap = {
    volatility: '波动率',
    sharp: '夏普比率',
    maxReturn: '最大回撤',
    trackingError: '跟踪误差',
  };
  const result = [];
  Object.keys(data).forEach((key) => {
    let empty = true;
    const item = data[key];
    const temp = [];
    Object.keys(item).forEach((key2) => {
      if (empty) {
        empty = isEmpty(item[key2].value);
      }

      let percent = 1 - (parseFloat(item[key2].rank) / parseFloat(item[key2].NumberOfSamples));
      if (percent * 100 < 0.5) {
        percent = 0.01;
      }
      if (percent * 100 > 99.5) {
        percent = 0.99;
      }
      let compare = isEmpty(percent) ? '--' : `优于${Number((percent) * 100).toFixed(0)}%同类`;
      if (Number.isNaN(percent)) {
        compare = '暂无排行';
      }
      const index = Math.floor(percent * 4);
      if (key2 !== 'trackingError' || BTYPE === '04') {
        let value = '';
        if (key2 !== 'sharp') {
          value = isEmpty(item[key2].value) ? '--' : `${numeral(item[key2].value).format('0.00')}%`;
        } else {
          value = isEmpty(item[key2].value) ? '--' : `${numeral(item[key2].value).format('0.00')}`;
        }

        temp.push({
          key: key2,
          name: descMap[key2],
          value,
          percent: isEmpty(percent) ? '' : percent,
          levelText: configMap[key2][index],
          compare,
        });
      }
    });
    result.push({
      isEmpty: empty,
      list: temp,
    });
  });
  return result;
}

// 交易规则
function handleTradeRule(params) {
  const imgActive = 'https://j5.dfcfw.com/sc/image/202109/20210924063844.png';
  const imgDisable = 'https://j5.dfcfw.com/sc/image/202109/20210924063905.png';
  const colorActive = '#ff4400';
  const colorDisable = '#999999';
  const handleStyle = ((isActive) => ({
    img: isActive ? imgActive : imgDisable,
    color: isActive ? colorActive : colorDisable,
  }));
  const {
    CURRENTDAYMARK,
    STKTOCASH,
    STKEXCHG,
    FUNDEXCHG,
    CASHBUY,
    BAGTYPE,
    BUY,
    RDMCFMDATADAY,
    tradeMarkList,
  } = params;
  let dayStr = '';
  if (RDMCFMDATADAY !== '--') {
    const sureDay = tool.getWeekFromDate(tool.splitDateTime(RDMCFMDATADAY));
    if (sureDay) {
      dayStr = sureDay;
    }
  }
  const tradeProcessList = [
    {
      desc: '买入',
      time: CURRENTDAYMARK,
    },
    {
      desc: '确认份额',
      time: `${!isEmpty(RDMCFMDATADAY?.slice(-5)) ? RDMCFMDATADAY?.slice(-5) : '--'} ${dayStr}`,
    },
    {
      desc: '查看盈亏',
      time: !isEmpty(RDMCFMDATADAY?.slice(-5)) ? `${RDMCFMDATADAY?.slice(-5)}净值更新后` : '--',
    },
  ];
  // 底部购买按钮 事件
  let tagList = [];
  if (BAGTYPE === '1') {
    // 活期宝
    tagList = [
      {
        title: '买基金',
        ...handleStyle(BUY),
      },
      {
        title: '极速取现，最快1秒到账',
        ...handleStyle(true),
      },
    ];
  } else {
    tagList = [
      {
        title: '活期宝支付',
        ...handleStyle(CASHBUY === '1'),
      },
      {
        title: '极速回活期宝',
        ...handleStyle(STKTOCASH === '1'),
      },
      {
        title: '超级转换',
        ...handleStyle(FUNDEXCHG === '1' || STKEXCHG === '1'),
      },
    ];
  }

  return {
    tradeProcessList,
    tagList,
    tradeMarkList,
  };
}

// 底部费率信息
function handleBottomRateInfo(params) {
  const {
    sourceRate, rate, isSales, minSG, SGZT, SHZT, TSRQ,
  } = params;
  let isShowRate;
  let isTSFund = false;
  let buyPoint = '';
  let buyState = '--';
  let nextPoint = '--';
  // 退市
  if (TSRQ?.length > 4) {
    const tsDate = new Date(TSRQ.replace(/-/g, '/')).getTime();
    const now = new Date().getTime();
    if (now > tsDate) {
      isTSFund = true;
    }
  }
  // 购买起点
  if (isSales - 0 === 1) {
    isShowRate = true;
    if (!isEmpty(minSG) && parseInt(minSG, 10) !== 100) {
      buyPoint = `购买起点：${parseInt(minSG, 10)}元`;
    }
  } else {
    isShowRate = false;
  }
  // 购买状态
  if (SGZT === SHZT) {
    buyState = SGZT;
    buyPoint = '';
  } else if (SGZT === '开放申购' && SHZT === '开放赎回') {
    buyState = '';
  } else {
    buyPoint = '';
    buyState = `${SGZT} ${SHZT}`;
  }
  let oldRate = sourceRate;
  if (isEmpty(rate) || ['0%', '0.0%', '0.00%', sourceRate].indexOf(rate) >= 0) {
    oldRate = '--';
  }
  if (isTSFund) {
    buyPoint = '';
    nextPoint = '';
  }

  return {
    isShowRate,
    isTSFund,
    buyPoint,
    buyState,
    nextPoint,
    rate,
    oldRate,
  };
}

function formatStockMarket(stockInfo, netValue, lastValuation) {
  if (isEmpty(stockInfo)) return {};
  const configMap = {
    0: '--',
    1: '开盘竞价',
    2: '交易中',
    3: '盘中休市',
    4: '收盘竞价',
    5: '已收盘',
    6: '停牌',
    7: '退市',
    8: '暂停上市',
    9: '未上市',
    10: '未开盘',
    11: '盘前(美股)',
    12: '盘后(美股)',
    13: '休市',
    14: '盘中停牌',
    15: '非交易代码',
    16: '波动性中断',
    17: '盘后交易',
    18: '盘后交易',
    19: '盘后交易',
  };
  const tradeTime = isEmpty(stockInfo?.f86) || stockInfo?.f86 === '-'
    ? '--' : formatDate(new Date(stockInfo?.f86), 'MM-dd hh:mm:ss');
  const tradeStatus = isEmpty(stockInfo?.f292) || stockInfo?.f292 === '-'
    ? '--' : configMap[stockInfo?.f292] || '--';
  const price = isEmpty(stockInfo?.f43) || stockInfo?.f43 === '-'
    ? '--' : numeral(stockInfo?.f43).format('0.000');
  const priceChange = isEmpty(stockInfo?.f169) || stockInfo?.f169 === '-'
    ? '--' : numeral(stockInfo?.f169).format('0.000');
  const priceRise = isEmpty(stockInfo?.f170) || stockInfo?.f170 === '-'
    ? '--' : `${numeral(stockInfo?.f170).format('0.00')}%`;
  // 今开
  const todayOpenPrice = isEmpty(stockInfo?.f46) || stockInfo?.f46 === '-'
    ? '--' : numeral(stockInfo?.f46).format('0.000');
  // 昨收
  const yesterdayClosePrice = isEmpty(stockInfo?.f60) || stockInfo?.f60 === '-'
    ? '--' : numeral(stockInfo?.f60).format('0.000');
  // 净值 netValue
  // 折价率
  let tempRate = '--';
  const temp = isEmpty(price) || isEmpty(lastValuation) ? '--' : ((lastValuation - price) / lastValuation) * 100;
  if (isEmpty(temp)) {
    tempRate = isEmpty(price) ? '--' : ((netValue - price) / netValue) * 100;
  } else {
    tempRate = temp;
  }
  const discountRate = isEmpty(tempRate) ? '--' : `${numeral(tempRate).format('0.00')}%`;
  // 最高
  const highestPrice = isEmpty(stockInfo?.f44) || stockInfo?.f44 === '-'
    ? '--' : numeral(stockInfo?.f44).format('0.000');
  // 最低
  const lowestPrice = isEmpty(stockInfo?.f45) || stockInfo?.f45 === '-'
    ? '--' : numeral(stockInfo?.f45).format('0.000');
  // 涨停价
  const limitUpPrice = isEmpty(stockInfo?.f51) || stockInfo?.f51 === '-'
    ? '--' : numeral(stockInfo?.f51).format('0.000');
  // 跌停价
  const limitDownPrice = isEmpty(stockInfo?.f52) || stockInfo?.f52 === '-'
    ? '--' : numeral(stockInfo?.f52).format('0.000');
  // 成交量
  const volume = isEmpty(stockInfo?.f47) || stockInfo?.f47 === '-'
    ? '--' : `${numeral(stockInfo?.f47).format('0.00A')}手`;
  // 成交额
  const turnover = isEmpty(stockInfo?.f48) || stockInfo?.f48 === '-'
    ? '--' : numeral(stockInfo?.f48).format('0.00A');
  return {
    netValue,
    tradeTime,
    tradeStatus,
    price,
    priceChange,
    priceRise,
    todayOpenPrice,
    yesterdayClosePrice,
    discountRate,
    highestPrice,
    lowestPrice,
    limitUpPrice,
    limitDownPrice,
    volume,
    turnover,
  };
}

export default {
  handleHeaderTags,
  handleFixedInvestList,
  formatFundSize,
  formatDays,
  handleFeatureData,
  handleTradeRule,
  handleBottomRateInfo,
  formatStockMarket,
};
